export default __webpack_public_path__ + "static/media/ko.e32283e1.jpg";